module.exports = __webpack_public_path__ + "static/calathea-lancifolia-60906fa9f6b8e85448e2d68b3b4e0630.svg";